import { envToBoolean } from './env';

/**
 * Check if the Entri domain purchasing feature is enabled for the current user
 *
 * @param {string|null|undefined} userEmail - The email address of the current user
 * @returns {boolean} Whether the Entri feature should be shown
 */
export const isEntriEnabled = (userEmail) => {
    const entriEnabled = envToBoolean(process.env.REACT_APP_ENTRI_ENABLED);
    const ghostOnly = envToBoolean(process.env.REACT_APP_ENTRI_GHOST_ONLY);

    if (!entriEnabled) {
        return false;
    }

    if (ghostOnly) {
        if (!userEmail || typeof userEmail !== 'string') {
            return false;
        }

        return userEmail.toLowerCase().endsWith('@ghost.org');
    }

    return true;
};

/**
 * Check if Entri debug mode is enabled
 *
 * @returns {boolean} Whether to use Entri in debug mode (no real purchases)
 */
export const isEntriDebugMode = () => {
    return envToBoolean(process.env.REACT_APP_ENTRI_DEBUG_MODE);
};
